import { Box } from '@mui/material'

export const SpaceBox = (): JSX.Element => <Box flexGrow={1} />
